module.exports = __webpack_public_path__ + "img/stripe-background@2x.a6780720.webp";